<template>
  <floating-menu :disabled="disabled">
    <template #button>
      <b-badge :variant="`${light ? 'light-' : ''}${resolveVariant(value)}`">
        {{ label }}
        <feather-icon icon="ChevronDownIcon" size="12" />
      </b-badge>
    </template>

    <template #default="{ close }">
      <a
        v-for="option in options"
        :key="option.value"
        href="#"
        class="dropdown-item"
        :class="{ active: option.value === value }"
        @click.prevent="
          close();
          select(option.value);
        "
      >
        {{ option.label }}
      </a>
    </template>
  </floating-menu>
</template>

<script>
import { BBadge } from 'bootstrap-vue';
import FloatingMenu from './FloatingMenu.vue';
import { title } from '@core/utils/filter';

/**
 * A badge that opens a dropdown and reports the choice, for values that are
 * changed through an action rather than a plain field write (makeup, transfer
 * of credit). The parent runs the action and owns the value.
 */
export default {
  name: 'ActionBadgeDropdown',
  components: { BBadge, FloatingMenu },
  props: {
    value: { type: [String, Boolean], default: undefined },
    /** [{ label, value }] in display order. */
    options: { type: Array, required: true },
    resolveVariant: { type: Function, default: () => 'secondary' },
    light: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
  },
  emits: ['select'],
  computed: {
    label() {
      const option = this.options.find((entry) => entry.value === this.value);
      return option ? option.label : title(this.value || 'N/A');
    },
  },
  methods: {
    select(value) {
      if (value !== this.value) this.$emit('select', value);
    },
  },
};
</script>
